import React, { useState } from "react";
import { getFlag, getFlagArray } from "../utils";
import { useTranslation } from "react-i18next";
import { Select } from "antd";

export interface EnumSelectProps {
  type: any;
  value?: any;
  defaultValue?: any;
  isFlag?: boolean;
  onChange?: (e: any) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  className?: string;
}

export const EnumSelect = React.memo(
  ({ type, value, defaultValue, isFlag, onChange, placeholder, allowClear = true, disabled, className }: EnumSelectProps) => {
    const [t] = useTranslation();
    const [selectedFlag, setSelectedFlag] = useState(isFlag && value ? getFlagArray(value) : []);

    const getKeyValueArray = () => {
      let keys = Object.keys(type).filter((x) => isNaN(parseInt(x)));

      if (isFlag) {
        keys = keys.filter((k) => type[k]);
      }
      let result = keys.map((k) => ({ key: k, value: type[k] }));

      return result;
    };

    const selectFlag = (values: number[]) => {
      setSelectedFlag(values);

      if (onChange) {
        onChange(getFlag(values) || null); // 0 is null
      }
    };

    return (
      <Select
        defaultValue={defaultValue}
        value={isFlag ? selectedFlag : value}
        placeholder={placeholder || "انتخاب کنید"}
        mode={isFlag ? "multiple" : undefined}
        onChange={isFlag ? selectFlag : onChange}
        style={{ width: "100%" }}
        allowClear={allowClear}
        maxTagCount={"responsive"}
        disabled={disabled}
        className={className}>
        {getKeyValueArray().map(({ key, value }) => (
          <Select.Option key={key} value={value}>
            {t(`enum.${key}`)}
          </Select.Option>
        ))}
      </Select>
    );
  }
);
